const STATUS_LABEL = {
  SUBMITTED:       { label: 'Submitted',       icon: '📨' },
  UNDER_REVIEW:    { label: 'Under Review',    icon: '🔍' },
  ACTION_REQUIRED: { label: 'Action Required', icon: '⚠️' },
  DRAFT_SENT:      { label: 'Draft Sent',      icon: '📋' },
  APPROVED:        { label: 'Approved',        icon: '✅' },
  FILED:           { label: 'Filed',           icon: '🏛' },
  ACKNOWLEDGED:    { label: 'Acknowledged',    icon: '🎉' },
  REJECTED:        { label: 'Rejected',        icon: '❌' },
};

export default function StatusBadge({ status }) {
  const s = STATUS_LABEL[status] || { label: status, icon: '•' };
  return (
    <span className={`badge badge-${status?.toLowerCase()}`}>
      {s.icon} {s.label}
    </span>
  );
}
